export type DownloadExportDefaultRoutes = {
  path: string;
  name: string;
};

export const DOCUMENTS_EXPORT_ROUTE =
  '/user/downloads-exports/documents-export';

export const DOCUMENTS_DOWNLOAD_ROUTE =
  '/user/downloads-exports/documents-download';

export const DEFAULT_DOWNLOAD_EXPORTS_ROUTES: DownloadExportDefaultRoutes[] = [
  {
    name: 'Document Downloads',
    path: DOCUMENTS_DOWNLOAD_ROUTE,
  },
  {
    name: 'Exports',
    path: DOCUMENTS_EXPORT_ROUTE,
  },
];
